/**
 * Utilidades de texto compartidas por las pantallas del buscador v2 — las del
 * Catálogo y las del BackOffice.
 *
 * Están aquí y no duplicadas en cada componente por un motivo concreto: el
 * regex de acentos usa un rango de caracteres combinantes que, escrito con
 * los caracteres literales, es invisible en el código fuente y cualquier
 * editor o cambio de codificación lo destroza sin dejar rastro. Con una sola
 * copia y las secuencias de escape explícitas, eso no puede pasar.
 */

/**
 * Quita los acentos para comparar.
 *
 * La búsqueda del servidor usa la intercalación de SQL Server, insensible a
 * acentos: "cirugia" encuentra "Cirugía". El `includes` de JavaScript no.
 * Sin esto, el filtrado en cliente se comportaría distinto que el del
 * servidor dentro de la misma caja de búsqueda.
 */
export const sinAcentos = (texto) =>
  (texto || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')

/**
 * Mismo saneado de nombre que usa el catálogo antiguo para construir la URL:
 * quita los paréntesis y su contenido.
 */
export const limpiarNombre = (nombre) => (nombre || '').replace(/ *\([^)]*\) */g, '')

/** Segmento de URL para el nombre de una família. */
export const segmentoNombre = (nombre) => encodeURIComponent(limpiarNombre(nombre))

/** Separador entre los eslabones de un camino. */
export const SEPARADOR_CAMINO = ' › '

/**
 * Separador entre dos caminos distintos.
 *
 * No es una coma a propósito: hay categorías que llevan comas en el nombre
 * —"Mobiliario, Almacenaje y Transporte"—, y con coma no se sabría dónde
 * acaba un camino y empieza el siguiente.
 */
export const SEPARADOR_ENTRE_CAMINOS = ' · '

/**
 * El camino completo de una ubicación: "Categoría › Família › Subfamília".
 *
 * `rutaPadres` de la categoría son las carpetas de ESA ubicación, no las del
 * artículo, así que una categoría secundaria enseña su propio camino y no el
 * de la principal. Un producto que cuelga directo de la categoría se queda
 * con el nombre a secas.
 *
 * Vive aquí, y no en el componente que lo usa, porque lo comparten el listado
 * del BackOffice —que construye cadenas para la tabla— y CategoriasAlternativas
 * —que las pinta en la ficha y en el formulario—. Es la misma noción de
 * "camino" en las tres pantallas y tiene que leerse igual en las tres.
 */
export const caminoDe = (categoria) =>
  [categoria.nombre, ...((categoria && categoria.rutaPadres) || []).map((p) => p.nombre)]
    .join(SEPARADOR_CAMINO)
